var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 10.5H3.75V7.125C3.75 6.82663 3.63147 6.54048 3.4205 6.32951C3.20952 6.11853 2.92337 6 2.625 6C2.32663 6 2.04048 6.11853 1.8295 6.32951C1.61853 6.54048 1.5 6.82663 1.5 7.125V29.625C1.5 29.9234 1.61853 30.2095 1.8295 30.4205C2.04048 30.6315 2.32663 30.75 2.625 30.75C2.92337 30.75 3.20952 30.6315 3.4205 30.4205C3.63147 30.2095 3.75 29.9234 3.75 29.625V25.125H33V29.625C33 29.9234 33.1185 30.2095 33.3295 30.4205C33.5405 30.6315 33.8266 30.75 34.125 30.75C34.4234 30.75 34.7095 30.6315 34.9205 30.4205C35.1315 30.2095 35.25 29.9234 35.25 29.625V16.125C35.25 14.6332 34.6574 13.2024 33.6025 12.1475C32.5476 11.0926 31.1168 10.5 29.625 10.5ZM3.75 12.75H13.875V22.875H3.75V12.75ZM16.125 22.875V12.75H29.625C30.5201 12.75 31.3786 13.1056 32.0115 13.7385C32.6444 14.3714 33 15.2299 33 16.125V22.875H16.125Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.a868b424ee9d7d10dc48c08c63b65adc.svg";
export { ForwardRef as ReactComponent };